import { useEffect } from "react";
import AOS from "aos";

const AboutUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  return (
    <div className="about-us" >
    <div className="first" data-aos="fade-right">
        <div className="column">
        <h1>About Us</h1>
       <p> Checkoff Finance Company Ltd is a privately-run finance company founded in 2021; we metamorphosed from Checkoff credit (originally founded in 2017). Our business was set up with the express purpose of offering unsecured loans to workers, payroll loans to public and private sector employees. These remain our raison d’etre, but, as time has passed, we have grown our business to provide additional support services.</p>
        </div>
        <div className="about-us-img">
            <img src={`${process.env.PUBLIC_URL}/assets/img/about-us-first.png`} alt="img"/>

        </div>
    </div>

    <div className="second" data-aos="fade-right">
    <div className="column">
    <h1>For all and sundry!</h1>
    <p>We offer tailored investment opportunities designed for different classes of investor to help them grow their wealth, and also meet their financial goals.</p>
</div>
<div className="about-us-img">
    <img className="float-right" src={`${process.env.PUBLIC_URL}/assets/img/about-us-second.png`} alt="img"/>

</div>
    </div>

    <div className="third" data-aos="fade-right">
    <div className="column">
    <h1>Committed to you!</h1>
    <p>Checkoff is a fast-growing finance company built on integrity and diligence. We adhere strictly to our core values which are, commitment, teamwork, innovation and people first, and this has set us apart uniquely from other finance companies in the Nigerian Industry. We are committed to delivering exceptional value and services, while also building trusted relationships with clients in order to meet their business and personal financial needs. At Checkoff Finance, our customers come first.</p>

</div>
<div className="about-us-img">
    <img src={`${process.env.PUBLIC_URL}/assets/img/about-us-third.png`} alt="img"/>

</div>
    </div>
   
    </div>
  );
};

export default AboutUs;
